import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const TwoColumnView = () => {
  const screenWidth = window.innerWidth < 1600 ? window.innerWidth : 1600;

  return screenWidth < 768 ? (
    <div
      style={{
        display: 'block',
        lineHeight: 2.5,
        padding: '1rem',
        marginBottom: '3rem',
      }}
    >
      <Skeleton height={28} />
      <Skeleton height={window.innerWidth * 0.75} />
      <Skeleton height={16} />
      <Skeleton count={5} height={50} />
    </div>
  ) : (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'block',
          lineHeight: 2.5,
          padding: '1rem',
          marginBottom: '3rem',
          width: screenWidth / 2,
        }}
      >
        <Skeleton height={28} />
        <Skeleton height={window.innerWidth * 0.35} />
        <Skeleton height={16} />
      </div>
      <div
        style={{
          display: 'block',
          lineHeight: 2.5,
          padding: '1rem',
          marginBottom: '3rem',
          width: screenWidth / 2,
        }}
      >
        <Skeleton count={5} height={50} />
      </div>
    </div>
  );
};

export default TwoColumnView;
